import {
  submitJob as publicSubmitJob,
  createFileUploadUrl as publicCreateFileUploadUrl,
  getJob as publicGetJob,
  listJobs as publicListJobs,
  queryJobs as publicQueryJobs,
  typedQueryJobs as publicTypedQueryJobs,
  terminateJob as publicTerminateJob,
  listMovementLogs as publicListMovementLogs,
} from './hub-v1-job-movement-jobs.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  DataMovementJobQuery,
  JobsQueryBuilder,
  typedQueryJobs as universalTypedQueryJobs,
} from './hub-v1-job-movement-jobs.universal.js';
import { onJobCreated as publicOnJobCreated } from './hub-v1-job-movement-jobs.public.js';
import { onJobDeleted as publicOnJobDeleted } from './hub-v1-job-movement-jobs.public.js';
import { onJobUpdated as publicOnJobUpdated } from './hub-v1-job-movement-jobs.public.js';

function customQueryJobs(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryJobs(httpClient)(),
    typedQueryFunction: (query: DataMovementJobQuery) =>
      publicTypedQueryJobs(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): JobsQueryBuilder;
  function overloadedQuery(
    query: DataMovementJobQuery
  ): ReturnType<typeof universalTypedQueryJobs>;
  function overloadedQuery(query?: DataMovementJobQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const submitJob: MaybeContext<
  BuildRESTFunction<typeof publicSubmitJob> & typeof publicSubmitJob
> = /*#__PURE__*/ createRESTModule(publicSubmitJob);
export const createFileUploadUrl: MaybeContext<
  BuildRESTFunction<typeof publicCreateFileUploadUrl> &
    typeof publicCreateFileUploadUrl
> = /*#__PURE__*/ createRESTModule(publicCreateFileUploadUrl);
export const getJob: MaybeContext<
  BuildRESTFunction<typeof publicGetJob> & typeof publicGetJob
> = /*#__PURE__*/ createRESTModule(publicGetJob);
export const listJobs: MaybeContext<
  BuildRESTFunction<typeof publicListJobs> & typeof publicListJobs
> = /*#__PURE__*/ createRESTModule(publicListJobs);
export const terminateJob: MaybeContext<
  BuildRESTFunction<typeof publicTerminateJob> & typeof publicTerminateJob
> = /*#__PURE__*/ createRESTModule(publicTerminateJob);
export const listMovementLogs: MaybeContext<
  BuildRESTFunction<typeof publicListMovementLogs> &
    typeof publicListMovementLogs
> = /*#__PURE__*/ createRESTModule(publicListMovementLogs);
export const queryJobs: MaybeContext<
  BuildRESTFunction<typeof customQueryJobs> & typeof customQueryJobs
> = /*#__PURE__*/ createRESTModule(customQueryJobs);
/**
 * Triggered when a job is submitted.
 */
export const onJobCreated: BuildEventDefinition<typeof publicOnJobCreated> &
  typeof publicOnJobCreated = createEventModule(publicOnJobCreated);
/**
 * Triggered when a job is terminated.
 */
export const onJobDeleted: BuildEventDefinition<typeof publicOnJobDeleted> &
  typeof publicOnJobDeleted = createEventModule(publicOnJobDeleted);
/**
 * Triggered when a job's `status` updates.
 */
export const onJobUpdated: BuildEventDefinition<typeof publicOnJobUpdated> &
  typeof publicOnJobUpdated = createEventModule(publicOnJobUpdated);

export {
  JobStatus,
  SortOrder,
  FieldType,
  WixDataEnvironment,
  FileFormat,
  MediaType,
  WixDataDestinationWritePolicy,
  WixMediaDestinationWritePolicy,
  WritePolicy,
  Units,
  CommonSortOrder,
  WebhookIdentityType,
} from './hub-v1-job-movement-jobs.universal.js';
export {
  DataMovementJob,
  DataMovementJobStatusOptionsOneOf,
  Source,
  SourceSourceOneOf,
  AggregationPipeline,
  AggregationPipelinePagingMethodOneOf,
  Stage,
  StageStageOneOf,
  Group,
  Expression,
  ExpressionValueOneOf,
  AddOperation,
  SumOperation,
  SubtractOperation,
  MultiplyOperation,
  DivideOperation,
  AbsOperation,
  ModOperation,
  FloorOperation,
  CeilOperation,
  ConcatOperation,
  StringifyOperation,
  ToLowerOperation,
  ToUpperOperation,
  SubstringOperation,
  LengthOperation,
  ConditionOperation,
  GreaterThanOperation,
  SizeOperation,
  GroupId,
  Accumulator,
  AccumulatorExpressionOneOf,
  Avg,
  Min,
  Max,
  Sum,
  First,
  Last,
  Push,
  Sorting,
  CommonSorting,
  Projection,
  Include,
  Exclude,
  Reshape,
  ProjectNested,
  Field,
  FieldProjectionOneOf,
  ObjectToArray,
  UnwindArray,
  AddFields,
  AddField,
  Lookup,
  UnionWith,
  Paging,
  CursorPaging,
  V1Field,
  FilterQuery,
  AggregationQuery,
  WixDataSource,
  WixDataSourceQueryOneOf,
  LocalizationSource,
  FileSource,
  TestSource,
  DataMovementJobLogs,
  ExternalFileSource,
  GoogleSheetsSource,
  WixMediaSource,
  WixDataCollectionDefinitionSource,
  Destination,
  DestinationDestinationOneOf,
  WixDataDestination,
  LocalizationDestination,
  FileDestination,
  Schema,
  StoresCatalogProductsDestination,
  WixMediaDestination,
  WixDataCollectionDefinitionDestination,
  StoresCatalogInventoryDestination,
  TestDestination,
  Transformation,
  TransformationTransformationOneOf,
  TestTransformation,
  Progress,
  ItemsSuccessfulInfo,
  ApplicationError,
  PartiallySuccessfulStatusOptions,
  ExtendedFields,
  SubmitJobRequest,
  SubmitJobRequestSiteOverrideOneOf,
  SubmitJobResponse,
  CreateFileUploadUrlRequest,
  CreateFileUploadUrlResponse,
  GetJobRequest,
  GetJobResponse,
  ListJobsRequest,
  CommonCursorPaging,
  QueryV2,
  QueryV2PagingMethodOneOf,
  WixCommonSorting,
  CommonPaging,
  ListJobsResponse,
  CursorPagingMetadata,
  Cursors,
  QueryJobsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  QueryJobsResponse,
  TerminateJobRequest,
  TerminateJobResponse,
  ListMovementLogsRequest,
  ListMovementLogsResponse,
  MovementLog,
  JobCallback,
  JobCallbackOptionsOneOf,
  InProgressOptions,
  FailedOptions,
  PartiallySuccessfulOptions,
  Empty,
  TerminateJobByIdRequest,
  TerminateJobByIdResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  JobCreatedEnvelope,
  JobDeletedEnvelope,
  JobUpdatedEnvelope,
  SubmitJobOptions,
  SubmitJobOptionsSiteOverrideOneOf,
  CreateFileUploadUrlOptions,
  ListJobsOptions,
  JobsQueryResult,
  JobsQueryBuilder,
  DataMovementJobQuerySpec,
  ListMovementLogsOptions,
} from './hub-v1-job-movement-jobs.universal.js';
export { utils } from './hub-v1-job-movement-jobs.universal.js';
export {
  JobStatusWithLiterals,
  SortOrderWithLiterals,
  FieldTypeWithLiterals,
  WixDataEnvironmentWithLiterals,
  FileFormatWithLiterals,
  MediaTypeWithLiterals,
  WixDataDestinationWritePolicyWithLiterals,
  WixMediaDestinationWritePolicyWithLiterals,
  WritePolicyWithLiterals,
  UnitsWithLiterals,
  CommonSortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  DataMovementJobQuery,
} from './hub-v1-job-movement-jobs.universal.js';
